import { API_URL } from '../constants';

const SIGN_LANGUAGE_API_URL = `${API_URL}/sign-language/spoken_text_to_signed_pose`;

/**
 * Fetches a sign language pose animation.
 * The backend handles translation (RO -> EN) and fallback logic.
 *
 * @param {string} text - The phrase (Romanian)
 * @param {string} signedLang - Sign language code (e.g., "ase" for ASL)
 * @returns {Promise<{ blobUrl: string, isFallback: boolean }>}
 */
export async function fetchSignLanguagePose(
  text,
  signedLang = 'ase'
) {
  const url = `${SIGN_LANGUAGE_API_URL}?text=${encodeURIComponent(
    text
  )}&signed=${encodeURIComponent(signedLang)}`;

  const response = await fetch(url);

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Sign language API error (${response.status}): ${errorText}`
    );
  }

  const isFallback = response.headers.get('X-Is-Fallback') === 'true';
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);

  return { blobUrl, isFallback };
}
